import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faUsers,
  faBoxOpen,
  faMapMarkerAlt,
  faFlagCheckered,
  faClock,
  faUserClock,
  faUser,
  faHandshake,
  faFile,
  faFileDownload,
  faFileContract,
  faFileSignature,
  faEye,
  faExpand,
  faExclamationTriangle,
  faExclamationCircle,
  faFireAlt,
  faDragon,
  faCircle,
  faCheckCircle,
  faExclamation,
  faFilter,
  faSignOutAlt,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faSearch,
  faTimes,
  faTimesCircle,
  faCaretDown,
  faHourglassStart,
  faHourglassEnd,
  faRubleSign,
  faTruck,
  faArchive,
  faCheck,
  faHistory,
  faPrint,
  faSquare,
  faCheckSquare,
  faAngleDoubleLeft,
  faAngleLeft,
  faAngleRight,
  faAngleDoubleRight,
  faTrash,
  faEdit,
  faAsterisk,
  faEllipsisV,
  faEnvelope,
  faAt,
  faPaperclip
} from '@fortawesome/free-solid-svg-icons'

import {
  faCheckCircle as farCheckCircle,
  faCircle as farCircle,
  faBuilding as farBuilding,
  faArrowAltCircleUp as farArrowAltCircleUp,
  faArrowAltCircleDown as farArrowAltCircleDown,
  faComment as farComment,
  faTrashAlt as farTrashAlt
} from '@fortawesome/free-regular-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faUsers,
  faBoxOpen,
  faMapMarkerAlt,
  faFlagCheckered,
  faClock,
  faUserClock,
  faUser,
  faHandshake,
  faFile,
  faFileContract,
  faFileSignature,
  faFileDownload,
  faEye,
  faExpand,
  faExclamationTriangle,
  faExclamationCircle,
  faFireAlt,
  faDragon,
  faCircle,
  faCheckCircle,
  farCheckCircle,
  farCircle,
  faExclamation,
  farBuilding,
  faFilter,
  faSignOutAlt,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faSearch,
  faTimes,
  faTimesCircle,
  faCaretDown,
  faHourglassStart,
  faHourglassEnd,
  faRubleSign,
  faTruck,
  faArchive,
  faCheck,
  farArrowAltCircleUp,
  farArrowAltCircleDown,
  faHistory,
  farComment,
  faPrint,
  faSquare,
  faCheckSquare,
  faAngleDoubleLeft,
  faAngleLeft,
  faAngleRight,
  faAngleDoubleRight,
  faTrash,
  farTrashAlt,
  faEdit,
  faAsterisk,
  faEllipsisV,
  faEnvelope,
  faAt,
  faPaperclip
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
